module.exports = __webpack_public_path__ + "img/cortona-cathedral.c14378c0.jpg";